"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const callAPI = (url, body, method) => __async(void 0, null, function* () {
  try {
    const response = yield fetch(url, __spreadValues({
      method: method || "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }, body && { body: JSON.stringify(body) }));
    const data = yield response.json();
    if (!response.ok) {
      throw new Error((data == null ? void 0 : data.message) || data.error || "Something went wrong, please try again");
    }
    return data;
  } catch (error) {
    console.log(error);
  }
});
export default callAPI;
export const callPaginatedAPI = (url, body, method) => __async(void 0, null, function* () {
  try {
    const response = yield fetch(url, __spreadValues({
      method: method || "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }, body && { body: JSON.stringify(body) }));
    const data = {
      data: yield response.json(),
      totalItems: Number(response.headers.get("X-Total-Count")),
      totalPages: Number(response.headers.get("X-Total-Pages"))
    };
    if (!response.ok) {
      throw new Error((data == null ? void 0 : data.message) || data.error || "Something went wrong, please try again");
    }
    return data;
  } catch (error) {
    console.log(error);
  }
});
